export default "__VITE_ASSET__CZ4Kw1oh__"